var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isOpen)?_c('common-modal',{attrs:{"width":"large","height":"full"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('download-timeline',{attrs:{"appointments":_vm.appointments},on:{"download-pdf":function($event){return _vm.$emit('close')}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }